import request from '../utils/request';

// 获取IP黑名单列表
export const getIPBlacklistList = (params) => {
    return request.get('/ip_black/get_list', { params });
};

// 删除IP黑名单
export const deleteIPBlacklist = (id) => {
    return request.get('/ip_black/delete', { params: { id } });
};

// 添加IP到黑名单
export const createIPBlacklist = (ips) => {
    return request.post('/ip_black/create', { ip: ips });
};
